import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const SetupLayout = ({ className, header, body, bgColor }) => {
  return (
    <div
      className={cn(styles.root, className)}
      style={{ '--bg-color': bgColor }}
    >
      <header className={styles.header}>{header}</header>
      <div className={styles.body}>{body}</div>
    </div>
  );
};

export default SetupLayout;
